import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["photoUrl", "referralProgram", "userEmail", "userPhone", "liveStreamingState", "personalProductListConfiguration", "videoShoppingConfiguration"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Avatar, Box, Link, Stack, styled, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { MenuItemPersonalLinks } from "../MenuItem/MenuItemPersonalLinks";
import { Trans } from "../Trans";
import { useTranslation } from "../../hooks";
import { MenuContentTestIds, TranslationKeys } from "../../models";

/**
 * Avatar size. Value is in pixels
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AVATAR_SIZE = 170;

/**
 * Maximal content width. Value is in pixels
 */
var MAX_CONTENT_WIDTH = 658;
var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
    maxWidth: MAX_CONTENT_WIDTH
  };
});
var ItemContentWrap = styled(Stack)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: 'block',
    marginTop: theme.spacing(2.5)
  };
});
var MenuItemPersonalLinksWrap = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    svg: {
      width: 22,
      height: 24,
      ml: theme.spacing(0.8),
      mr: theme.spacing(0.6)
    }
  };
});
var LinkWrap = styled(Typography)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: 'block',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1.5)
  };
});
var StyledAvatar = styled(Avatar)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    margin: theme.spacing(4)
  };
});
export var MenuContent = function MenuContent(_ref6) {
  var photoUrl = _ref6.photoUrl,
    referralProgram = _ref6.referralProgram,
    userEmail = _ref6.userEmail,
    userPhone = _ref6.userPhone,
    liveStreamingState = _ref6.liveStreamingState,
    personalProductListConfiguration = _ref6.personalProductListConfiguration,
    videoShoppingConfiguration = _ref6.videoShoppingConfiguration,
    restProps = _objectWithoutProperties(_ref6, _excluded);
  var _useTestId = useTestId(),
    getTestIdProps = _useTestId.getTestIdProps;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _ref7 = referralProgram !== null && referralProgram !== void 0 ? referralProgram : {},
    benefitsLink = _ref7.benefitsLink,
    greetingMessage = _ref7.greetingMessage,
    message = _ref7.message;
  return /*#__PURE__*/_jsxs(Root, _objectSpread(_objectSpread(_objectSpread({
    sx: {
      display: 'flex'
    }
  }, getTestIdProps(MenuContentTestIds.ROOT)), restProps), {}, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        justifyContent: 'flex-start'
      },
      children: /*#__PURE__*/_jsxs(ItemContentWrap, {
        direction: "column",
        spacing: 2,
        children: [/*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
          variant: "h6",
          color: "textPrimary"
        }, getTestIdProps(MenuContentTestIds.HEADING)), {}, {
          children: greetingMessage
        })), /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
          variant: "body2",
          color: "textPrimary"
        }, getTestIdProps(MenuContentTestIds.TEXT)), {}, {
          children: /*#__PURE__*/_jsx(Trans, {
            defaults: message !== null && message !== void 0 ? message : undefined,
            components: {
              emphasis: /*#__PURE__*/_jsx("strong", _objectSpread({}, getTestIdProps(MenuContentTestIds.USER_NAME)))
            }
          })
        })), benefitsLink !== null && benefitsLink !== void 0 && benefitsLink.relativeUrl && benefitsLink.title ? /*#__PURE__*/_jsx(LinkWrap, {
          children: /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
            href: benefitsLink.relativeUrl,
            variant: "button"
          }, getTestIdProps(MenuContentTestIds.BENEFITS_LINK)), {}, {
            children: benefitsLink.title
          }))
        }) : null, userEmail ? /*#__PURE__*/_jsx(LinkWrap, {
          children: /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
            href: "mailto:".concat(userEmail)
          }, getTestIdProps(MenuContentTestIds.USER_EMAIL)), {}, {
            children: userEmail
          }))
        }) : null, userPhone ? /*#__PURE__*/_jsx(LinkWrap, {
          children: /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
            href: "tel:".concat(userPhone)
          }, getTestIdProps(MenuContentTestIds.USER_PHONE)), {}, {
            children: userPhone
          }))
        }) : null, /*#__PURE__*/_jsx(MenuItemPersonalLinksWrap, {
          children: /*#__PURE__*/_jsx(MenuItemPersonalLinks, {
            personalProductListConfiguration: personalProductListConfiguration,
            videoShoppingConfiguration: videoShoppingConfiguration,
            liveStreamingState: liveStreamingState,
            photoUrl: photoUrl
          })
        })]
      })
    }), photoUrl ? /*#__PURE__*/_jsx(Box, {
      sx: {
        justifyContent: 'flex-end'
      },
      children: /*#__PURE__*/_jsx(StyledAvatar, _objectSpread({
        src: photoUrl,
        alt: t(TranslationKeys.SponsorPhoto)
      }, getTestIdProps(MenuContentTestIds.AVATAR)))
    }) : null]
  }));
};